
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { AuthorizationHelper as _authorization } from '@/helper/authorization.helper';
import { VendorTypeAccountModel } from '@/models/accounting/vendor';
import { Base } from '@/components/common/base';
import { Utils } from '@/helper/utils';
import { IDialogOption } from '@/models/dialog';
import {getVendorTypeHeaders} from '@/views/admin/vendortype/vendorType';
import {vendorService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Stores: () => import('@/components/common/store.select.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class VendorTypeAccountPage extends Base {
    public headers: VHeaders[] = getVendorTypeHeaders(this);
    public pagedAccounts: VendorTypeAccountModel[] = [];
    public pagination = new PaginationModel('name');
    public selectedStore: number = 0;
    public accounts: VendorTypeAccountModel[] = [];
    public searched: boolean = true;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public storeId: number;
    public loading: boolean = true;
    public accountToDelete: VendorTypeAccountModel;
    public actions: any[] = [{
        type: 'link',
        title: this.$parent.$t('vendorTypeAccount.vendorTypeAccountGridHeader.gridAction.edit') as string,
        icon: 'fas fa-edit',
        action: this.generateUrl,
    }
        , {
        type: 'button',
        title: this.$parent.$t('vendorTypeAccount.vendorTypeAccountGridHeader.gridAction.delete') as string,
        icon: 'fas fa-trash-alt',
        color: 'error',
        action: this.confirmDelete,
    }];
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('vendorTypeAccount.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteAccount();
        },
    };

    public created() {
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
        } else {
            this.storeId = this.userSession.storeId;
        }
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addAccount') {
            this.$router.push({ name: 'admin.vendortypeaccounts.add', params: { storeId: this.storeId.toString(), dms: 'false' } });
        } else if (methodName === 'addAccountFromDMS') {
            this.$router.push({ name: 'admin.vendortypeaccounts.add', params: { storeId: this.storeId.toString(), dms: 'true' } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('vendorTypeAccount.btnAddAccount'), disabled: false, visible: true, class: 'btn', label: this.$t('vendorTypeAccount.btnAddAccount'), click: 'addAccount', icon: 'fas fa-plus-circle' });
        buttons.push({ id: '1', type: 'button', title: this.$t('vendorTypeAccount.btnAddAccountFromDMS'), disabled: false, visible: true, class: 'btn', label: this.$t('vendorTypeAccount.btnAddAccountFromDMS'), click: 'addAccountFromDMS', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'vendorTypeAccount');

        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin', 'S-Admin'])) {
            this.getAccountByStore();
        }
    }
    public async getAccountByStore(): Promise<void> {
        this.searched = false;
        this.loading = true;
        try {
            const response = await vendorService.getVendorTypeAccountByStoreAsync
                (this.pagination, this.storeId);
            this.pagedAccounts = response.results;
            this.pagination.totalItems = response.total;
        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    }
    public confirmDelete(selected: VendorTypeAccountModel): void {
        this.accountToDelete = selected;
        this.deleteDialog.model = true;
    }
    public async deleteAccount(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await vendorService.deleteVendorTypeAccountAsync(this.accountToDelete.id, this.storeId);
            this.showAlert(true, this.$t('vendorTypeAccount.alertDeleteVendorTypeAccount'));
            this.deleteDialog.model = false;
            this.getAccountByStore();
        } finally {
            this.deleteDialog.loading = false;
        }
    }
    public generateUrl(props: VendorTypeAccountModel): any {
        return {
            name: 'admin.vendortypeaccounts.edit',
            params: {
                storeId: this.storeId.toString(),
                id: props.id.toString(),
            },
        };
    }
    public updatePaging(paging: any): void {
        this.pagination = paging;
        this.getAccountByStore();
    }
    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getAccountByStore();
        this.searched = false;
    }
}
